/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiArtifactFromJSON, StreemApiArtifactToJSON, } from './';
export function StreemApiListMeshesResponseFromJSON(json) {
    return StreemApiListMeshesResponseFromJSONTyped(json, false);
}
export function StreemApiListMeshesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'meshArtifacts': !exists(json, 'mesh_artifacts') ? undefined : (json['mesh_artifacts'].map(StreemApiArtifactFromJSON)),
        'nextPageToken': !exists(json, 'next_page_token') ? undefined : json['next_page_token'],
        'totalSize': !exists(json, 'total_size') ? undefined : json['total_size'],
    };
}
export function StreemApiListMeshesResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'mesh_artifacts': value.meshArtifacts === undefined ? undefined : (value.meshArtifacts.map(StreemApiArtifactToJSON)),
        'next_page_token': value.nextPageToken,
        'total_size': value.totalSize,
    };
}
//# sourceMappingURL=StreemApiListMeshesResponse.js.map